import { render, staticRenderFns } from "./CashboxTransferComponent.vue?vue&type=template&id=0970208c&scoped=true"
import script from "./CashboxTransferComponent.vue?vue&type=script&lang=ts"
export * from "./CashboxTransferComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970208c",
  null
  
)

export default component.exports